<template>
	<div class="card">
		<div class="card__header">
			<h4 class="card__title">Вывод средств</h4>
		</div>

		<div class="nav-line fields__item" role="tablist">
			<button class="nav-line__item" type="button" :class="{active: active === 'withdraw'}" @click="active = 'withdraw'">
				Вывод
			</button>
			<button class="nav-line__item" type="button" :class="{active: active === 'history'}" @click="active = 'history'">
				История
			</button>
		</div>

		<div v-if="active === 'withdraw'" id="withdraw">

			<PaymentSystems v-if="types?.length" :items="types" :selected-type="selectedType" @set-type="setType"/>

			<div class="fields__item" v-if="selectedType && selectedType.currency">
				<span class="badge badge--xs badge--lighter">
					1 {{ selectedType.title }} ≈ {{ $root.currency(selectedType.currency) }}
				</span>
			</div>

			<div class="fields__item" v-if="selectedType?.banks?.length">
				<label class="text-field__label">
					Банк
				</label>
				<FieldSelect :options="selectedType.banks" placeholder="Выберите банк" @update:model-value="handlerSetBank"/>
			</div>

			<div class="fields__item">
				<label class="text-field__label">
					Реквизиты
				</label>
				<input autocomplete="off" class="text-field__input" type="text" v-model="wallet" placeholder="Введите реквизиты" name="wallet">
			</div>

			<div class="fields__item">
				<label class="text-field__label">
					Сумма <span v-if="selectedType">от {{ $root.currency(selectedType.min_amount) }} до {{ $root.currency(selectedType.max_amount) }}&#160;</span>
					<span v-if="selectedType" class="badge badge--xs badge--lighter">
						Комиссия: {{ selectedType.commission }}%
					</span>
				</label>

				<input autocomplete="off" class="text-field__input" type="number" v-model="amount" placeholder="Введите сумму" @input="validateSum" name="amount">
			</div>

			<button :disabled="!canSendWithdraw" @click="withdrawSock"
					class="btn btn--primary btn--block fields__item">
				Вывести
			</button>
		</div>

		<div class="" v-if="active === 'history'" id="history">
			<div class="table-wrap fields__item">
				<table class="table">
					<thead>
						<tr>
							<th>Инфо</th>
							<th>Сумма</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
					<tr v-for="withdraw in withdraws" :key="withdraw.id">
						<td>
							<span class="lead">{{ withdraw.id }}</span>
							<div class="text-muted">{{ withdraw.date }}</div>
						</td>
						<td>
							<div class="withdraw__data-state">
								<img class="withdraw__table-icon" :src="withdraw.icon">
								<div class="div">
									<span class="lead">{{ withdraw.amount.toFixed(2) }} ₽
								</span>
									<div class="withdraw__table-sub">{{ withdraw.wallet }}</div>
								</div>

							</div>
						</td>
						<td class="tnx-type">
                       		<span v-if="withdraw.status === 'performed' || withdraw.status === 'pending' || withdraw.status === 'deferred'">
                            	<span class="badge badge--warning badge--md">
                                	В обработке
                                	</span>
								</span>
							<span v-if="withdraw.status === 'processed'">
								<span class="badge badge--success badge--md">
									Выполнено
								</span>
							</span>
							<span v-if="withdraw.status === 'canceled' || withdraw.status === 'failed'">
								<span class="badge badge--danger badge--md">
									Отменено
								</span>
							</span>
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<div class="btn btn--lighter-alt btn--block" v-show="page < totalPages && !loader" @click="getMoreWithdraws">
				<svg width="22" height="22">
					<use href="#svg-icon-dots"></use>
				</svg>
			</div>
			<Loader class="fields__item" :loading="loader" static/>
		</div>
	</div>
</template>

<script>
	import FieldSelect from "../../components/blocks/FieldSelect.vue";
	import { useUserStore } from '../../stores/User';
	import {mapState} from "pinia";
	import PaymentSystems from "../../components/blocks/PaymentSystems.vue";
	import Loader from "../../components/blocks/Loader.vue";

    export default {

		components: {
			Loader,
			PaymentSystems,
			FieldSelect
		},

        data() {
            return {
                loader: false,
                amount: null,
                wallet: null,
                types: [],
                selectedType: false,
                page: 1,
                disableBtn: false,
                withdraws: [],
                totalPages: 0,
                showAddForm: false,
				active: 'withdraw',
				selectedBank: null
            }
        },
        computed: {
			...mapState(useUserStore, ['user']),

            canSendWithdraw: function () {
				return this.selectedType && this.wallet && this.amount && !this.selectedType.banks.length || this.selectedType && this.wallet && this.amount && this.selectedType.banks.length && this.selectedBank;
            }
        },
        mounted() {
            this.getTypes();
            this.getWithdraws();
        },
        methods: {
            validateSum() {
                this.amount = this.amount.toString();
                this.amount = this.amount.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
            }, 
            withdrawSock() {
                if (!this.wallet) {
                    return this.$toast.error('Укажите реквизиты');
                }

                if(!this.selectedType) {
                    return this.$toast.error('Выберите способ вывода');
                }

                if(!this.amount) {
                    return this.$toast.error('Укажите сумму вывода');
                }

                this.amount = parseInt(Math.round(this.amount), 10);

				if(!this.wallet) {
					return this.$toast.error('Укажите реквизиты');
				}

                if (this.amount < this.selectedType.min_amount) {
                    return this.$toast.error(`Минимальная сумма вывода для данного способа ${this.selectedType.min_amount}`);
                }

                if (this.amount > this.selectedType.max_amount) {
                    return this.$toast.error(`Максимальная сумма вывода для данного способа ${this.selectedType.max_amount}`);
                }

                if(this.amount > this.user.balance) {
                    return this.$toast.error('На вашем балансе недостаточно средств');
                }

				if(this.selectedType.banks.length && !this.selectedBank) {
					return this.$toast.error('Необходимо выбрать банк для вывода средств');
				}

                // if(!this.user.has_pin) {
                //     return this.$toast.error('Для вывода средств требуется установить PIN-код в разделе настройки');
                // }

                // if(this.user.pin_expire_timestamp <= Date.now() / 1000) {
                //     return this.$root.emitter.emit('showPin');
                // }

                if (this.disableBtn) {
                    return;
                }

                this.disableBtn = true;

                this.$root.axios.post('/api/withdraws', {
                    amount: this.amount,
                    type_id: this.selectedType.id,
                    wallet: this.wallet,
					bank_id: this.selectedBank
                }).then(res => {
                    this.user.balance = res.data.balance;
                    this.$toast.success(res.data.message);

                    this.amount = null;
                    this.wallet = null;
					this.selectedBank = null;
                    this.page = 1;

                    this.getWithdraws();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            getWithdraws() {
				this.loader = true;
                this.$root.axios.get('/api/withdraws', {
                    params: {
                        page: this.page
                    }   
                }).then(res => {
					this.withdraws = this.page > 1 ? this.withdraws.concat(res.data.withdraws) : res.data.withdraws;
					this.totalPages = res.data.total_pages;
					this.disableBtn = false;
                }).catch(error => {
					this.$toast.error(this.$root.graphql.axiosGetError(error));
					this.disableBtn = false;
                });

				this.loader = false;
            },
            getTypes() {
                this.$root.axios.get('api/withdraw/types')
                .then(res => {
                    this.types = res.data;
                })
                .catch(error => {
                    this.$router.push({name: 'index'});
                    this.$root.isLoading = false;
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            setType(type) {
                this.selectedType = type;
				this.selectedBank = null;
            },
            getMoreWithdraws() {
                if(this.page >= this.totalPages) {
                    this.loader = false;
                    return;
                }

                this.page += 1;
                this.loader = true;
                this.getWithdraws();
            },
            setWallet(walletId) {
                this.selectedWallet = walletId;
            },
            saveWallet() {
                if(!this.selectedType) {
                    return this.$toast.error('Выберите платежную систему');
                }

                if(!this.wallet) {
                    return this.$toast.error('Укажите реквизиты платежной системы');
                }

                this.$root.axios.post('/api/wallet/store', {
                    withdraw_type_id: this.selectedType.id,
                    wallet: this.wallet
                }).then(res => {
                    this.getTypes();
                    
                    this.wallet = null;
                    this.selectedType = false;
                    this.selectedWallet = false;

                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
			handlerSetBank(bank) {
				if (bank) {
					this.selectedBank = bank.id;
				}
			}
        },
        sockets: {
            withdraw_complete: function() {
                this.page = 1;
                this.loader = true;

                this.getWithdraws();
            }
        }
    }
</script>
<style scoped>
.system-img {
    width: 40px;
    height: 40px;
}
</style>